/* eslint-disable no-continue */

/* eslint-disable no-restricted-syntax */
import { compareVariantKeys } from "shared/lib/variant-key/compareVariantKeys"

import { FieldMatch } from "../types/GlobalSearch"

export function computeVariantKeyMatchInfo(
  searchVariantKeys: string[],
  buildingReferenceVariantKeys: (string | null | undefined)[]
): FieldMatch[] {
  const results: FieldMatch[] = []

  for (const brKey of buildingReferenceVariantKeys) {
    if (!brKey) continue

    let best:
      | { matchedCount: number; ranges2: number[]; searchKey: string }
      | undefined

    for (const searchKey of searchVariantKeys) {
      const result = compareVariantKeys(searchKey, brKey, {
        wildcardMode: "partial"
      })
      if (result && result.matchedCount > (best?.matchedCount ?? -1)) {
        best = {
          matchedCount: result.matchedCount,
          ranges2: result.ranges2,
          searchKey
        }
      }
    }

    if (!best) continue

    results.push({
      value: brKey,
      searchTerm: best.searchKey,
      ranges: best.ranges2
    })
  }

  return results
}
